<template>
  <main-layout>
    <div class="container fluid">
      <template>
        <h3 class="headline">{{ $t('Customer') }}</h3>
        <div>
          <v-layout wrap>
            <v-flex xs12 sm7 lg9 class="pl-1"></v-flex>
            <v-flex xs12 sm5 lg3 class="form-control">
              <input
                type="text"
                class="form-control ma-0"
                v-model="search"
                :placeholder="$t('Search')"
              />
            </v-flex>
          </v-layout>
        </div>
        <v-data-table
          :headers="headers"
          :items="data"
          :loading="loading"
          hide-actions
          :pagination.sync="pagination"
          class="elevation-1 mt-4"
          :search="search"
        >
          <!-- hide-actions -->
          <template v-slot:items="props">
            <tr>
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.linename }}</td>
              <td class="py-2">{{ props.item.address || '-' }}</td>
              <td class="py-2">
                {{ props.item.favoriteproducts || '-' }}
              </td>
              <td>
                <a href="javascript:void(0);" @click="showOrderHistory(props.item.id)">
                  ประวัติการสั่งซื้อ
                </a>
              </td>
            </tr>
          </template>
        </v-data-table>
      </template>
      <div class="mt-2">
        <v-pagination
          :total-visible="6"
          v-model="pageNumber"
          @input="changePage"
          :length="pagelength"
        ></v-pagination>
      </div>

      <!-- Modal Orders History -->
      <v-dialog persistent width="950px" v-model="orderModal">
        <v-card v-if="orderModal">
          <!-- @onsave="oneditmember" -->
          <OrderHistory @close="orderModal = false" :userid="userid"></OrderHistory>
        </v-card>
      </v-dialog>
    </div>
  </main-layout>
</template>

<script>
import api from '@/api'
import OrderHistory from './OrderHistory.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    OrderHistory
  },
  data() {
    return {
      pagination: { rowsPerPage: -1, sortBy: '' },
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      headers: [
        { text: 'ชื่อลูกค้า', value: 'name', width: '5%', sortable: false },
        { text: 'ชื่อไลน์', value: 'line', width: '1%', sortable: false },
        { text: 'ที่อยู่', value: 'address', width: '5%', sortable: false },
        { text: 'สินค้ารายการโปรด', value: 'favourite', width: '1%', sortable: false },
        { text: '', value: '', width: '2%', sortable: false }
      ],
      data: [],
      loading: false,
      orderModal: false,
      search: ''
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        var total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      var data = {
        pageid: this.selectedBot.pageid,
        limit: this.limit,
        offset: this.offset
      }
      api.foodguruGetCustomer(data, (err, response) => {
        if (response.responsecode == 200) {
          this.data = response.data
          this.loading = false
        } else {
          console.log(err)
        }
      })
    },
    showOrderHistory(id) {
      this.userid = id
      this.orderModal = true
    },
    changePage(val) {
      var vm = this

      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.page * vm.limit - vm.limit
        if (vm.page != 1) {
          vm.offset + 1
        }
        this.$emit('onChange', { limit: vm.limit, offset: vm.offset })
      }
      this.$emit('input', vm.page)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/foodguru/main.vue